import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2';

import InputField from 'components/LoginForm/Input';
import { HashLink as Link } from 'react-router-hash-link';

import countries from '../Register/registerCountriesData';
import states from '../Register/registerStatesData';
import hostAgencies from '../Register/registerHostAgenciesData';
import agencyAffiliations from '../Register/registerAgencyAffiliationsData';
import businessDescriptions from '../Register/registerBusinessDescriptionsData';
import { Multiselect } from 'multiselect-react-dropdown';

export default class RegisterTrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: '',
      selectedItems: [],
      options: [
        { name: 'DMO', id: 'DMO' },
        { name: 'Event Employee', id: 'Event Employee' },
        { name: 'Hotel Employee', id: 'Hotel Employee' },
        { name: 'Restaurant/Bar Employee', id: 'Restaurant/Bar Employee' },
        {
          name: 'Retail and service Employee',
          id: 'Retail and service Employee',
        },
        {
          name: 'Tour and Activity Operator Employee',
          id: 'Tour and Activity Operator Employee',
        },
        { name: 'Transportation Employee', id: 'Transportation Employee' },
        { name: 'Other', id: 'Other' },
      ],
      options2: [
        { name: 'Just arrived (<6 months)', id: 'Just arrived (<6 months)' },
        { name: '1 to 5 Years', id: '1 to 5 Years' },
        { name: '5 to 10 Years', id: '5 to 10 Years' },
        { name: '10+ Years', id: '10+ Years' },
      ],
    };
  }

  render() {
    const { selectedValue, options } = this.state;

    // Auto-detect mobile pages
    const isMobilePage = window.location.href.includes('mobile');

    return (
      <div className="Register">
        <p htmlFor="reg_years_of_experience" />
        <br />
        <InputField
          defaultVal={this.props.defaultVal}
          change={this.props.change}
          fieldType="email"
          fieldName="reg_email"
          fieldPlaceholder={i18n.translate('loginScreen.fields.email')}
          icon="envelope"
          line
          disabledField={window.location.pathname === '/login/quick-register'}
          required
        />
        {this.props.passwordField && (
          <InputField
            change={this.props.change}
            fieldType="password"
            fieldName="reg_password"
            fieldPlaceholder={i18n.translate('loginScreen.version2.fields.passwordRegister')}
            icon="key"
            line
          />
        )}
        {this.props.passwordField && (
          <InputField
            change={this.props.change}
            fieldType="password"
            fieldName="reg_passwordConfirm"
            fieldPlaceholder={i18n.translate('loginScreen.version2.fields.passwordConfirm')}
            icon="key"
            line
          />
        )}
        <div className="step space-top">
          {i18n.translate('loginScreen.version2.step3')}
        </div>
        <h5>
          <b>{i18n.translate('loginScreen.version2.step2Sub1')}</b>
        </h5>
        <InputField
          change={this.props.change}
          fieldType="text"
          fieldName="reg_first_name"
          fieldPlaceholder={i18n.translate('loginScreen.version2.fields.firstName')}
          icon="user"
          line
          defaultVal={this.props.userInput.reg_first_name}
          required
        />
        <InputField
          change={this.props.change}
          fieldType="text"
          fieldName="reg_last_name"
          fieldPlaceholder={i18n.translate('loginScreen.version2.fields.lastName')}
          icon="user"
          line
          defaultVal={this.props.userInput.reg_last_name}
          required
        />
        <p htmlFor="reg_country" className="reg_country">
          {i18n.translate('loginScreen.version2.fields.country')}
          {!isMobilePage && '*'}
        </p>
        <select
          id="reg_country"
          name="reg_country"
          onChange={this.props.change}
          value={this.props.userInput.reg_country}
          required={!isMobilePage}
        >
          <option value="" disabled selected>
            {i18n.translate('loginScreen.version2.fields.select')}
          </option>
          {countries.map((c, index) => {
            const key = index;
            return (
              <option key={key} value={c.code}>
                {c.name}
              </option>
            );
          })}
        </select>
        <InputField
          change={this.props.change}
          fieldType="text"
          fieldName="reg_zip_code"
          fieldPlaceholder={
            this.props.country === 'US'
              ? i18n.translate('loginScreen.version2.fields.zipCode')
              : i18n.translate('loginScreen.version2.fields.postalCode')
          }
          icon="user"
          line
          defaultVal={this.props.userInput.reg_zip_code}
          required={!isMobilePage}
        />
        <InputField
          change={this.props.change}
          fieldType="text"
          fieldName="reg_city"
          fieldPlaceholder={i18n.translate('loginScreen.version2.fields.city')}
          icon="user"
          line
          defaultVal={this.props.userInput.reg_city}
          required
        />
        {this.props.country !== 'US' && (
          <InputField
            change={this.props.change}
            fieldType="text"
            fieldName="reg_state"
            fieldPlaceholder={i18n.translate('loginScreen.version2.fields.province')}
            icon="map"
            line
            defaultVal={this.props.userInput.reg_state}
            required={!isMobilePage}
          />
        )}
        {this.props.country === 'US' && (
          <React.Fragment>
            <p htmlFor="reg_state" className="reg_state">
              {i18n.translate('loginScreen.version2.fields.state')} *
            </p>
            <select
              id="reg_state"
              name="reg_state"
              onChange={this.props.change}
              value={this.props.userInput.state}
              required={!isMobilePage}
            >
              <option value="" disabled selected>
                {i18n.translate('loginScreen.version2.fields.select')}
              </option>
              {states.map((c, index) => {
                const key = index;
                return (
                  <option key={key} value={c.value}>
                    {c.label}
                  </option>
                );
              })}
            </select>
          </React.Fragment>
        )}
        <h5 style={{ marginTop: '5rem' }}>
          <b>{i18n.translate('loginScreen.version2.step2Sub2')}</b>
        </h5>
        <InputField
          change={this.props.change}
          fieldType="text"
          fieldName="reg_agency_name"
          fieldPlaceholder={i18n.translate('loginScreen.version2.fields.agency')}
          icon="home"
          line
          defaultVal={this.props.userInput.reg_agency_name}
          required
        />
        <br />
        <p htmlFor="reg_title" className="reg_margin_top">
          {i18n.translate('loginScreen.version2.fields.title')} *
        </p>

        <select
          id="reg_title"
          name="reg_title"
          onChange={this.props.change}
          value={this.props.userInput.reg_title}
        >
          <option value="" disabled selected>
            {i18n.translate('loginScreen.version2.fields.select')}
          </option>
          <option value="DMO">DMO</option>
          <option value="Event Employee">Event Employee</option>
          <option value="Hotel Employee">Hotel Employee</option>
          <option value="Restaurant/Bar Employee">
            Restaurant/Bar Employee
          </option>
          <option value="Retail and service Employee">
            Retail and service Employee
          </option>
          <option value="Tour and Activity Operator Employee">
            Tour and Activity Operator Employee
          </option>
          <option value="Transportation Employee">
            Transportation Employee
          </option>
          <option value="Other">Other</option>
        </select>
        <p htmlFor="reg_years_of_experience" className="reg_margin_top">
          {i18n.translate('loginScreen.version2.fields.experience')} *
        </p>
        <select
          id="reg_years_of_experience"
          name="reg_years_of_experience"
          onChange={this.props.change}
          value={this.props.userInput.reg_years_of_experience}
        >
          <option value="" disabled selected>
            {i18n.translate('loginScreen.version2.fields.select')}
          </option>
          <option value="Just arrived (<6 months)">
            Just arrived (&lt;6 months)
          </option>
          <option value="1 to 5 Years">1 to 5 Years</option>
          <option value="5 to 10 Years">5 to 10 Years</option>
          <option value="10+ Years">10+ Years</option>
        </select>
        <div className="privacy">
          <b>{i18n.translate('loginScreen.version2.privacyHead')}</b>
          <br />
          {i18n.translate('loginScreen.version2.privacySub')}
          <br />
          <b>{i18n.translate('loginScreen.version2.privacy')}</b>
        </div>
        {this.props.country && (
          <span key={this.props.country}>
            <span className="checkItem">
              <InputField
                key={this.props.userInput.opt_in_marketing}
                change={this.props.change}
                fieldLabel={i18n.translate('loginScreen.version2.fields.opt')}
                fieldName="opt_in_marketing"
                fieldType="checkbox"
                icon="envelope"
                line={false}
                title={i18n.translate('loginScreen.fields.opt')}
                checked={this.props.userInput.opt_in_marketing}
                required={false}
                userSelect={false}
              />
            </span>

            <span className="checkItem">
              <InputField
                change={this.props.change}
                fieldLabel={i18n.translate('loginScreen.version2.fields.optMarketing')}
                fieldName="marketing_opt_in"
                fieldType="checkbox"
                line={false}
                title={i18n.translate('loginScreen.version2.fields.optMarketing')}
                checked={this.props.userInput.marketing_opt_in}
                required={false}
                userSelect={false}
                key={this.props.userInput.marketing_opt_in}
              />
            </span>
          </span>
        )}
        <div className="login__form--buttons">
          {window.location.pathname.includes('/register-mobile') &&
            window.location.pathname.includes('/login/register-mobile') &&
            window.location.pathname.includes('/login/quick-register-mobile') && (
              <style>
                {
                  '\
              #openWidget { display: none; bottom: 3rem; } #logoHeader { display: none; } .cookieConsent { display: none !important; } .loginView__content--logo { display: none !important; }'
                }
              </style>
            )}
          {window.location.pathname !== '/register-mobile' &&
            window.location.pathname !== '/login/register-mobile' &&
            window.location.pathname !== '/login/quick-register-mobile' && (
              <Link to="/login">
                <button
                  type="button"
                  onClick={this.props.back}
                  className="Email__input--button btnInverse"
                >
                  {i18n.translate('general.back')}
                </button>
              </Link>
            )}
          <button
            type="submit"
            onClick={this.props.submit}
            className="Email__input--button"
          >
            {this.props.loadingAnimRegister ? (
              <span>
                <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
              </span>
            ) : (
              i18n.translate('loginScreen.register')
            )}
          </button>
        </div>
      </div>
    );
  }
}

RegisterTrade.propTypes = {
  changeItem: PropTypes.func.isRequired,
  defaultVal: PropTypes.string,
  country: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
  passwordField: PropTypes.bool.isRequired,
  userInput: PropTypes.shape({
    reg_email: PropTypes.string,
    reg_first_name: PropTypes.string,
    reg_last_name: PropTypes.string,
    reg_agency_name: PropTypes.string,
    reg_country: PropTypes.string,
    reg_city: PropTypes.string,
    reg_state: PropTypes.string,
    state: PropTypes.string,
    reg_agency_affiliation: PropTypes.string,
    reg_title: PropTypes.string,
    reg_zip_code: PropTypes.string,
    reg_years_of_experience: PropTypes.string,
    marketing_opt_in: PropTypes.bool,
    opt_in_marketing: PropTypes.bool,
  }),
};

RegisterTrade.defaultProps = {
  defaultVal: '',
  userInput: {
    reg_email: '',
    reg_first_name: '',
    reg_last_name: '',
    reg_agency_name: '',
    reg_country: '',
    reg_city: '',
    reg_state: '',
    state: '',
    reg_agency_affiliation: '',
    reg_title: '',
    reg_zip_code: '',
    reg_years_of_experience: '',
    marketing_opt_in: false,
    opt_in_marketing: false,
  },
};
